<template>
    <div class="email-message-input">
        <ckeditor v-model="data" v-on:ckeditor="setCKEditor" v-on:input="onChange" :isTranslation="isTranslation"></ckeditor>
        <select @click.stop.prevent="" v-model="variable" @change="changeVariable" class="form-control btn-info">
            <option value="" disabled="disabled">Insert email variable...</option>
            <optgroup v-for="(vars, group) in variables" :label="group">
                <option v-for="v in vars" :value="v.value" :title="v.label">{{v.name}}</option>
            </optgroup>
        </select>

        <div class="modal fade email-program-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Insert Current Program(s) Variable</h4>
                    </div>
                    <div class="modal-body">
                        <p class="alert alert-info">
                            This variable will be replaced with the current programs that match the selected program types below.  If the student has multiple current programs matching these program types, they will be comma separated.  If the student has none, the message below will get displayed instead.
                        </p>
                        <h3>Include the following program types (blue = selected):</h3>
                        <ul class="list-group">
                            <li v-for="pt in program_types" @click="selectProgramType(pt)" :class="{'clickable': true, 'list-group-item': true, 'active': selectedProgramTypes.indexOf(pt.code) !== -1}">
                                {{pt.title}}
                            </li>
                        </ul>
                        <div class="form-group">
                            <label>Message to display if student has no matching programs</label>
                            <input type="text" class="form-control" v-model="programNoneMessage" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="insertProgramVariable(selectedProgramTypes, programNoneMessage)">Insert Variable</button>
                    </div>
                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->
    </div>
</template>

<script>
    export default {
        name: 'email-message',
        data() {
            let d = new Date();
            let currentDate = ("00" + (d.getMonth() + 1)).slice(-2) + "/" +
                ("00" + d.getDate()).slice(-2) + "/" +
                d.getFullYear() + " " +
                ("00" + d.getHours()).slice(-2) + ":" +
                ("00" + d.getMinutes()).slice(-2) + ":" +
                ("00" + d.getSeconds()).slice(-2);
            return {
                data: "",
                program_types: [],
                variable: "",
                programNoneMessage: "",
                selectedProgramTypes: [],
                bookmark: {},
                variables: {
                    "Student": [
                        {'name': "Common Name", 'value': "[name_common]", 'label': "Replaced with common_name, if present, otherwise first_name"},
                        {'name': "First Name", 'value': "[name_first]", 'label': "Replaced with first name"},
                        {'name': "Last Name", 'value': "[name_last]", 'label': "Replaced with last name"},
                        {'name': "Username", 'value': "[username]", 'label': "Replaced with student username"},
                        {'name': "Student ID#", 'value': "[student_id]", 'label': "Replaced with student ID number"},
                        {'name': "Programs (comma separated)", 'value': "[programs]", 'label': "Replaced with comma separated list of student programs"},
                        {'name': "Current Program(s)", 'value': "[program]", 'label': "Replaced with comma separated list of student programs based on selected options."},
                    ],
                    "Academic Calendar (Based on Term)": [
                        {'name':'Academic Year (2016-2017, etc)', 'value': "[academic_year]", 'label': ''},
                        {'name':'Term (Winter 2016, etc)', 'value': "[term_title]", 'label': ''},
                        {'name':'Term Type (Fall, Winter, Etc.)', 'value': "[term_type_title]", 'label': ''},
                        {'name':'Registration Start Date', 'value': "[registration_start]", 'label': ''},
                        {'name':'Registration End Date', 'value': "[registration_end]", 'label': ''},
                        {'name':'Classes Start Date', 'value': "[classes_start]", 'label': ''},
                        {'name':'Practicum Pre-Registration Deadline Date', 'value': "[practicum_prereg_end]", 'label': ''},
                        {'name':'Classes End Date', 'value': "[classes_end]", 'label': ''},
                        {'name':'Classes Drop 70% Deadline Date', 'value': "[drop_70]", 'label': ''},
                        {'name':'Classes Q-Drop Deadline Date', 'value': "[drop_q]", 'label': ''},
                        {'name':'Grades Due Date', 'value': "[grades_due]", 'label': ''},
                        {'name':'Coursesite Access Start Date', 'value': "[coursesite_start]", 'label': ''},
                        {'name':'Coursesite Access End Date', 'value': "[coursesite_end]", 'label': ''},
                    ],
                    "Other": [
                        {'name': "Countdown Timer", 'value': "[countdown=\"" + currentDate + "\"][/countdown]", 'label': "Replaced with a countdown timer to the given date."},
                    ],
                    "Custom": []
/*                        {'value': "[current_program_enrollment_term]", 'name': "Current program enrollment term"},
                        {'value': "[academic_year]", 'name': "Current academic program year"},
                        {'value': "[current_inprogress_term]", 'name': "Current in-progress term", 'label': "Current in-progress term"},
                        {'value': "[certificate_program_application_start_date]", 'name': "Certificate program applications start date", 'label': "Certificate program applications start date"},
                        {'value': "[certificate_program_application_cutoff]", 'name': "Certificate program applications due date (end of year)", 'label': "Certificate program applications due date (end of year)"},
                        {'value': "[certificate_program_application_cutoff_current_app_term]", 'name': "Certificate program applications (current program application term)", 'label': "Certificate program applications (current program application term)"},
                        {'value': "[dcm_references_due]", 'name': "DCM references due (current program application term)", 'label': "DCM references due (current program application term)"},
                        {'value': "[program_application_notification_date]", 'name': "Program application notification date", 'label': "Program application notification date"},
                        {'value': "[dcm_application_cutoff]", 'name': "DCM/BA application due date", 'label': "DCM/BA application due date"},
                        {'value': "[scholarship_cutoff]", 'name': "Gen. scholarship app due date", 'label': "Gen. scholarship app due date (opens on registration start date)"},
                        {'value': "[district_scholarship_cutoff]", 'name': "District scholarship app due date", 'label': "District scholarship app due date (opens on registration start date)"},
                        {'value': "[valencia_scholarship_references_due]", 'name': "Valencia Scholarship references due date", 'label': "Valencia Scholarship references due date"},
                        {'value': "[scholarship_notification_date]", 'name': "Scholarship notification date", 'label': "Scholarship notification date"},
                        {'value': "[registration_start_date]", 'name': "Registration start date", 'label': "Registration start date"},
                        {'value': "[registration_deadline]", 'name': "Registration deadline date", 'label': "Registration deadline date (full tuition is also due on this date)"},
                        {'value': "[down_payment_cutoff]", 'name': "Registration down payment due Date", 'label': "Down payment cutoff date (after this date students must pay full amount at registration)"},
                        {'value': "[course_drop_date]", 'name': "Registration course drop date", 'label': "Registration Course drop date (date to drop courses if tuition is not paid in full)"},
                        {'value': "[classes_begin_date]", 'name': "Classes begin date", 'label': "Classes begin Date"},
                        {'value': "[last_day_to_withdraw_date]", 'name': "Last day to withdraw from classes", 'label': "Last day to withdraw from classes"},
                        {'value': "[last_day_to_qdrop_date]", 'name': "Last day to Q drop a class", 'label': "Last day to Q drop a class"},
                        {'value': "[last_day_of_class]", 'name': "Last day of class", 'label': "Last day of class"},
                        {'value': "[grades_due_date]", 'name': "Grades due date", 'label': "Grades due date"},
                    ],*/
/*                    "Graduation": [
                        {'value': "[commencement_registration_cutoff]", 'name': "Commencement Registration Due Date", 'label': "Commencement Registration Due Date"}
                    ]*/
                },
            }
        },
        computed: {
            translation() {
                if(this.$i18n.locale() == 'en')
                {
                    return "English Translation";
                }
                else
                {
                    return "Spanish Translation";
                }
            }
        },
        props: {
            value: {default: ""},
            isTranslation: {default: true},
            is_variable: {default: false},
        },
        watch: {
            value(newVal, oldVal)
            {
                this.data = newVal;
            }
        },
        methods: {
            changeVariable() {
                switch(this.variable)
                {
                    case '[program]':
                        this.insertProgram();
                        break;
                    default:
                        this.inject(this.variable);
                }
                this.variable = ""
            },
            insertProgram() {
                this.programNoneMessage = "";
                this.selectedProgramTypes = [];
                //this.bookmark = this.ckeditor.getSelection().getRanges().createBookmarks2();
                $(this.$el).find('.email-program-modal').modal('show');

            },
            insertProgramVariable(pts, message) {
                let codes = pts.join(',');
               // this.ckeditor.focus();
                //this.ckeditor.getSelection().selectBookmarks(this.bookmark);
                this.inject('[program codes="' + codes + '" none="' + message + '"]');
                $(this.$el).find('.email-program-modal').modal('hide');
            },
            selectProgramType(pt) {
                if(this.selectedProgramTypes.indexOf(pt.code) !== -1)
                    this.selectedProgramTypes.splice(this.selectedProgramTypes.indexOf(pt.code), 1);
                else
                    this.selectedProgramTypes.push(pt.code);
            },
            onChange(args) {
                this.data = args;
                this.$emit('input', args);
            },
            setCKEditor(ckeditor) {
                this.ckeditor = ckeditor;
            },
            inject(value)
            {
                this.ckeditor.insertText(value);
            },
            refresh() {
                this.$http.get('/api/email/variable').then(response => {
                    this.variables["Custom"] = [];
                    response.data.variables.forEach(v => {
                        this.variables["Custom"].push({
                            value: '[' + v.variable + ']',
                            name: v.title,
                        });
                    });
                });
                this.$http.get('/api/program-type').then(response => {
                    this.program_types = response.data.types.sort(function(a,b) {
                        if(a.title == b.title) return 0;
                        if(a.title > b.title) return 1;
                        return -1;
                    });
                });
            }
        },
        mounted() {
            this.data = this.value;
            if(!this.is_variable)
                this.refresh();
            else
                delete this.variables["Custom"];
        },
    }
</script>
